<div class="pix-report-tab">
  <form
    [formGroup]="monthFilterForm"
    class="form-b4a pix-report-filter-form"
    (submit)="loadReportBySelectedMonth()"
  >
    <span class="p-float-label pix-report-filter-form__month">
      <p-calendar
        inputId="pixReportMonth"
        formControlName="month"
        view="month"
        dateFormat="mm/yy"
        [showIcon]="true"
      />
      <label for="pixReportMonth">Mes de referencia</label>
    </span>

    <div class="pix-report-filter-form__actions">
      <p-button
        icon="pi pi-chevron-left"
        type="button"
        severity="secondary"
        [outlined]="true"
        (onClick)="goToPreviousMonth()"
      />
      <p-button
        icon="pi pi-chevron-right"
        type="button"
        severity="secondary"
        [outlined]="true"
        (onClick)="goToNextMonth()"
      />
      <p-button
        label="Aplicar"
        icon="pi pi-search"
        type="submit"
        [disabled]="monthFilterForm.invalid"
      />
    </div>
  </form>

  <div class="pix-kpis" *ngIf="pixReportRows.length > 0">
    <div class="dashboard-card pix-kpi-card">
      <span class="header header--primary">Total agendadas</span>
      <span class="value">{{ kpiTotalScheduled }}</span>
    </div>
    <div class="dashboard-card pix-kpi-card">
      <span class="header header--success">Total pagas</span>
      <span class="value">{{ kpiTotalPaid }}</span>
    </div>
    <div class="dashboard-card pix-kpi-card">
      <span class="header header--warning">Total falhas</span>
      <span class="value">{{ kpiTotalFailed }}</span>
    </div>
    <div class="dashboard-card pix-kpi-card">
      <span class="header header--dark">Assinantes</span>
      <span class="value">{{
        (kpiTotalPaid || 0) + (kpiTotalFailed || 0) + (kpiTotalScheduled || 0)
      }}</span>
    </div>
    <div class="dashboard-card pix-kpi-card">
      <span class="header header--box">Aprovacao media</span>
      <span class="value">{{ kpiApprovalRate.toFixed(2) }}%</span>
    </div>
  </div>

  <div class="pix-chart-card" *ngIf="pixReportRows.length > 0">
    <h4>Tendencia diaria</h4>
    <p-chart type="bar" [data]="chartData" [options]="chartOptions" />
  </div>

  <app-table
    *ngIf="pixReportRows.length > 0"
    [lazy]="false"
    [elements]="pixReportRows"
    [cols]="pixReportCols"
    [addButton]="false"
    [exportExcel]="false"
    [exportPdf]="false"
    [showTitle]="false"
    modelName="cobrancas pix"
  />

  <div class="config-warning" *ngIf="pixReportRows.length === 0">
    Nenhuma cobranca Pix encontrada para o mes selecionado.
  </div>
</div>
